module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloudy-93759158ba02c55d6d168a885af6dcb3.svg";